(function () {
  var SCS = JSON.parse(document.getElementById('scs-config-data').textContent);

  // ── Pricing ──
  var PRICE_BUCKETS = {
    width:  [{max:30,tier:0},{max:48,tier:1},{max:76,tier:2}],
    height: [{max:24,tier:0},{max:40,tier:1},{max:65,tier:2}]
  };
  var PRICE_GRID = [
    [62,  78,  110],
    [79,  103, 129],
    [111, 154, 195]
  ];
  var ACTIVE_PRICE_BUCKETS = SCS.priceBuckets || PRICE_BUCKETS;

  function getBucketIndex(val, buckets) {
    if (!buckets || !buckets.length) return 0;
    var idx = buckets.length - 1;
    for (var i = 0; i < buckets.length; i++) {
      if (val <= buckets[i].max) { idx = i; break; }
    }
    return idx;
  }

  function getBasePrice(w, h, grid) {
    if (!w || !h) return null;
    var g = grid || getActivePriceGrid();
    var wt = getBucketIndex(w, ACTIVE_PRICE_BUCKETS.width);
    var ht = getBucketIndex(h, ACTIVE_PRICE_BUCKETS.height);
    return g[wt][ht];
  }

  function getActivePriceGrid() {
    if (_isDayNight && SCS.variantPriceMap) {
      // Build price grid from SCS.variantPriceMap for D/N
      return [
        [SCS.variantPriceMap[SCS.sizeTierVariants['0-30/0-24']] || 80, SCS.variantPriceMap[SCS.sizeTierVariants['0-30/25-40']] || 94, SCS.variantPriceMap[SCS.sizeTierVariants['0-30/41-65']] || 112],
        [SCS.variantPriceMap[SCS.sizeTierVariants['31-48/0-24']] || 108, SCS.variantPriceMap[SCS.sizeTierVariants['31-48/25-40']] || 128, SCS.variantPriceMap[SCS.sizeTierVariants['31-48/41-65']] || 150],
        [SCS.variantPriceMap[SCS.sizeTierVariants['49-76/0-24']] || 138, SCS.variantPriceMap[SCS.sizeTierVariants['49-76/25-40']] || 160, SCS.variantPriceMap[SCS.sizeTierVariants['49-76/41-65']] || 180]
      ];
    }
    if (_isDayNight && window._scsDNPriceGrid) return window._scsDNPriceGrid;
    if (SCS.priceGrid) return SCS.priceGrid;
    return PRICE_GRID;
  }

  function getBlackoutUpcharge(w, h) {
    if (!SCS.blackoutUpchargeGrid || !w || !h) return 0;
    var wt = getBucketIndex(w, ACTIVE_PRICE_BUCKETS.width);
    var ht = getBucketIndex(h, ACTIVE_PRICE_BUCKETS.height);
    return ((SCS.blackoutUpchargeGrid[wt] || [])[ht]) || 0;
  }

  function updateBlackoutCardBadge(w, h) {
    var badge = document.getElementById('scs-blackout-liner-badge');
    if (!badge) return;
    if (w > 0 && h > 0 && SCS.blackoutUpchargeGrid) {
      badge.textContent = '+$' + getBlackoutUpcharge(w, h);
    } else {
      badge.textContent = '+ Upcharge';
    }
  }

  function updatePriceBar() {
    var bar = document.getElementById('scs-price-bar');
    if (!bar) return;
    var wWhole = parseFloat(document.getElementById('scs-width-whole').value) || 0;
    var wFrac  = parseFloat(document.getElementById('scs-width-frac').value) || 0;
    var hWhole = parseFloat(document.getElementById('scs-height-whole').value) || 0;
    var hFrac  = parseFloat(document.getElementById('scs-height-frac').value) || 0;
    var qty    = parseInt((document.getElementById('scs-qty') || {}).value) || 1;
    var w = wWhole + wFrac;
    var h = hWhole + hFrac;
    var priceEl  = document.getElementById('scs-price-bar-amount');
    var labelEl  = document.getElementById('scs-price-bar-label');
    if (w > 0 && h > 0) {
      var base  = getBasePrice(w, h, getActivePriceGrid());
      if (window._scsBlackout === 'Add Blackout Liner') {
        base += getBlackoutUpcharge(w, h);
      }
      var total = base * qty;
      if (priceEl) priceEl.textContent = '$' + total.toFixed(2);
      if (labelEl) {
        var parts = [qty > 1 ? (qty + ' shades') : '1 shade'];
        if (window._scsBlackout === 'Add Blackout Liner') parts.push('includes blackout liner');
        labelEl.textContent = parts.join(' · ');
      }
      bar.classList.add('scs-price-bar--ready');
    } else {
      var fromPrice = SCS.initialPrice ? ('From $' + SCS.initialPrice) : (_isDayNight ? 'From $80' : 'From $46');
      if (priceEl) priceEl.textContent = fromPrice;
      if (labelEl) labelEl.textContent = 'Enter size to see price';
      bar.classList.remove('scs-price-bar--ready');
    }
    updateBlackoutCardBadge(w, h);
  }



  // ── State ──
  var _mount = 'Inside';
  var _lift = 'Corded';
  var _selectedVariant = '46243130867864';
  var _selectedFabric = 'cotton';
  var _selectedColorName = 'Cotton';
  var _selectedRail = null;
  var _selectedRailName = null;
  var _isDayNight = SCS.isDayNight || false;
  var _selectedDayFabric = null;
  var _selectedDayFabricName = null;
  var _pleatSize = null;
  var _liftStyle = null;
  var _bottomRail = null;
  var _blackout = null;
  window._scsShades = window._scsShades || []; var _savedShades = window._scsShades;
  window._scsBlackout = null;

  // ── Helpers ──
  function setText(id, val) {
    var el = document.getElementById(id);
    if (el) el.textContent = val;
  }

  function showMsg(cls, text) {
    var el = document.getElementById('scs-msg');
    if (!el) return;
    el.className = 'scs-msg ' + cls;
    el.textContent = text;
  }

  function clearMsg() {
    var el = document.getElementById('scs-msg');
    if (el) { el.className = 'scs-msg'; el.textContent = ''; }
  }

  function fmtDim(whole, frac) {
    var w = parseInt(whole) || 0;
    var f = parseFloat(frac) || 0;
    if (!w) return null;
    var map = {'0':'','0.25':'¼','0.5':'½','0.75':'¾'};
    var fs = map[String(f)] !== undefined ? map[String(f)] : (f > 0 ? String(f) : '');
    return w + (fs ? ' ' + fs : '') + '"';
  }

  function updateSizeSummary() {
    var ws = fmtDim(
      document.getElementById('scs-width-whole').value,
      document.getElementById('scs-width-frac').value
    );
    var hs = fmtDim(
      document.getElementById('scs-height-whole').value,
      document.getElementById('scs-height-frac').value
    );
    setText('scs-size-summary', (ws && hs) ? (ws + ' × ' + hs) : 'Enter width × height');
  }

  function addBusinessDays(date, days) {
    var d = new Date(date);
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var dow = d.getDay();
      if (dow !== 0 && dow !== 6) added++;
    }
    return d;
  }

  function fmtDate(d) {
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    return months[d.getMonth()] + ' ' + d.getDate();
  }

  function parseDeliveryRange(raw) {
    if (!raw) return null;
    // Format: "12-21" = 12 to 21 business days
    var m = String(raw).match(/^(\d+)-(\d+)$/);
    if (m) {
      var today = new Date();
      var earliest = addBusinessDays(today, parseInt(m[1]));
      var latest = addBusinessDays(today, parseInt(m[2]));
      return 'Arrives ' + fmtDate(earliest) + ' – ' + fmtDate(latest);
    }
    // Already a human string (e.g. "Built to order — typically arrives in 1–2 weeks.")
    return raw;
  }

  function updateDeliveryCopy() {
    var el = document.getElementById('scs-delivery-copy');
    if (!el) return;
    var raw = (SCS.variantDeliveryMap && SCS.variantDeliveryMap[_selectedVariant] != null)
      ? SCS.variantDeliveryMap[_selectedVariant]
      : SCS.initialLeadTime;
    raw = raw || el.getAttribute('data-raw-delivery');
    if (!raw) return;
    var label = parseDeliveryRange(raw);
    el.innerHTML = '<strong>' + label + '</strong> Custom pleated shades ship from Elkhart, Indiana after production.';
    el.style.visibility = 'visible';
  }


  function updateUnitedConstraints() {
    var wWholeEl = document.getElementById('scs-width-whole');
    var wFracEl  = document.getElementById('scs-width-frac');
    var width = (parseFloat(wWholeEl && wWholeEl.value) || 0) + (parseFloat(wFracEl && wFracEl.value) || 0);

    var linerBtn = document.getElementById('scs-blackout-liner-btn');
    var warn = document.getElementById('scs-blackout-warning');
    if (linerBtn) {
      if (width > 72) {
        linerBtn.classList.add('disabled');
        if (_blackout === 'Add Blackout Liner') {
          var noneBtn = document.getElementById('scs-blackout-none-btn');
          if (noneBtn) window.scsSelectBlackout('None', noneBtn);
        }
        if (warn) warn.style.display = 'block';
      } else {
        linerBtn.classList.remove('disabled');
        if (warn && _blackout !== 'Add Blackout Liner') warn.style.display = 'none';
      }
    }
  }

  // ── Shade list ──
  function renderShadeList() {
    var wrap = document.getElementById('scs-shade-list-wrap');
    var list = document.getElementById('scs-shade-list');
    var countEl = document.getElementById('scs-shade-count');
    var totalEl = document.getElementById('scs-shade-list-total');
    if (!wrap || !list) return;

    if (_savedShades.length === 0) {
      wrap.style.display = 'none';
      return;
    }

    wrap.style.display = 'block';
    if (countEl) countEl.textContent = _savedShades.length;

    var total = 0;
    list.innerHTML = '';
    _savedShades.forEach(function(shade, idx) {
      total += (shade.price || 0) * (shade.quantity || 1);
      var item = document.createElement('div');
      item.className = 'scs-shade-list-item';
      var label = shade.label || 'Custom Shade';
      var meta = shade.summaryText || '';
      var priceStr = shade.price ? ('$' + ((shade.price * (shade.quantity || 1)).toFixed(2))) : '';
      item.innerHTML = '<div class="scs-shade-list-item-info">' +
        '<div class="scs-shade-list-item-title">' + label + '</div>' +
        '<div class="scs-shade-list-item-meta">' + meta + '</div>' +
        '</div>' +
        (priceStr ? '<div class="scs-shade-list-item-price">' + priceStr + '</div>' : '') +
        '<button class="scs-shade-list-remove" onclick="window.scsRemoveShade(' + idx + ')" title="Remove">×</button>';
      list.appendChild(item);
    });

    if (totalEl) totalEl.textContent = '$' + total.toFixed(2);
  }

  function scsResetForm() {
    // Reset all selections to defaults
    _selectedVariant = '46243130867864';
    _selectedFabric = 'cotton';
    _selectedColorName = 'Cotton';
    _selectedRail = null;
    _selectedRailName = null;
    _mount = 'Inside';
    _lift = 'Corded';
    _pleatSize = null;
    _liftStyle = null;
    _bottomRail = null;
    _blackout = null;
    window._scsBlackout = null;

    // Reset DOM
    document.getElementById('scs-width-whole').value = '';
    document.getElementById('scs-width-frac').value = '0';
    document.getElementById('scs-height-whole').value = '';
    document.getElementById('scs-height-frac').value = '0';
    var qtyEl = document.getElementById('scs-qty');
    if (qtyEl) qtyEl.value = 1;
    var wnEl = document.getElementById('scs-window-name');
    if (wnEl) wnEl.value = '';

    // Reset swatch selections
    document.querySelectorAll('.scs-color-card').forEach(function(c) { c.classList.remove('active'); });
    var firstColor = document.querySelector('#scs-colors .scs-color-card');
    if (firstColor) {
      firstColor.classList.add('active');
      _selectedVariant = firstColor.dataset.variant || _selectedVariant;
      _selectedFabric = firstColor.dataset.fabric || firstColor.dataset.color || _selectedFabric;
      _selectedColorName = firstColor.dataset.color || firstColor.dataset.fabric || _selectedColorName;
    }
    var firstDay = document.querySelector('#scs-day-colors .scs-day-color-card');
    if (firstDay) {
      document.querySelectorAll('.scs-day-color-card').forEach(function(c) { c.classList.remove('active'); });
      firstDay.classList.add('active');
      _selectedDayFabric = firstDay.dataset.fabric || null;
      _selectedDayFabricName = firstDay.dataset.color || null;
    }

    // Reset mount buttons
    document.querySelectorAll('[data-option-group="mount"] .scs-mount-btn').forEach(function(b) { b.classList.remove('active'); });
    var insideBtn = document.querySelector('[data-option-group="mount"] .scs-mount-btn');
    if (insideBtn) insideBtn.classList.add('active');

    document.querySelectorAll('[data-option-group="pleat-size"] .scs-mount-btn').forEach(function(b) { b.classList.remove('active'); });
    var pleatBtn = document.querySelector('[data-option-group="pleat-size"] .scs-mount-btn');
    if (pleatBtn) { pleatBtn.classList.add('active'); _pleatSize = pleatBtn.dataset.pleat || '5/8"'; }

    document.querySelectorAll('[data-option-group="lift-style"] .scs-lift-card').forEach(function(b) {
      b.classList.remove('active');
      var badge = b.querySelector('.scs-lift-badge');
      if (badge && badge.dataset.defaultLabel) badge.textContent = badge.dataset.defaultLabel;
    });
    var liftStyleBtn = document.querySelector('[data-option-group="lift-style"] .scs-lift-card:not(.disabled)');
    if (liftStyleBtn) {
      liftStyleBtn.classList.add('active');
      _liftStyle = liftStyleBtn.dataset.liftStyle || 'EZ Lift';
      var lbadge = liftStyleBtn.querySelector('.scs-lift-badge');
      if (lbadge) lbadge.textContent = 'Selected';
    }

    document.querySelectorAll('[data-option-group="bottom-rail"] .scs-mount-btn').forEach(function(b) { b.classList.remove('active'); });
    var bottomRailBtn = document.querySelector('[data-option-group="bottom-rail"] .scs-mount-btn');
    if (bottomRailBtn) { bottomRailBtn.classList.add('active'); _bottomRail = bottomRailBtn.dataset.rail || 'Fingertip'; }

    document.querySelectorAll('[data-option-group="blackout"] .scs-lift-card').forEach(function(b) {
      b.classList.remove('active');
      var badge = b.querySelector('.scs-lift-badge');
      if (badge && badge.dataset.defaultLabel) badge.textContent = badge.dataset.defaultLabel;
    });
    var blackoutBtn = document.querySelector('[data-option-group="blackout"] .scs-lift-card');
    if (blackoutBtn) {
      blackoutBtn.classList.add('active');
      _blackout = blackoutBtn.dataset.blackout || 'None';
      window._scsBlackout = _blackout;
      var bbadge = blackoutBtn.querySelector('.scs-lift-badge');
      if (bbadge) bbadge.textContent = 'Selected';
    }
    var colors = document.getElementById('scs-colors');
    var note = document.getElementById('scs-laminated-note');
    if (colors) colors.classList.remove('scs-colors-disabled');
    if (note) note.classList.remove('visible');

    // Update displays
    setText('scs-color-summary', _selectedColorName);
    setText('scs-mount-summary', _mount + ' Mount');
    if (_isDayNight) setText('scs-day-color-summary', _selectedDayFabricName || 'Select sheer');
    setText('scs-lift-summary', _lift);
    if (SCS.showRailColor !== false) setText('scs-rail-summary', 'Select rail');
    setText('scs-pleat-summary', _pleatSize || '5/8"');
    setText('scs-lift-style-summary', _liftStyle || 'EZ Lift');
    setText('scs-bottom-rail-summary', _bottomRail || 'Fingertip');
    setText('scs-blackout-summary', 'No Blackout');
    updateUnitedConstraints();
    updateSizeSummary();
    updatePriceBar();
    clearMsg();

    // Scroll to top of configurator
    var root = document.getElementById('scs-root');
    if (root) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // ── Color selection ──
  window.scsSelectColor = function (el) {
    document.querySelectorAll('.scs-color-card:not(.scs-rail-card)').forEach(function (c) {
      c.classList.remove('active');
    });
    el.classList.add('active');
    _selectedVariant = el.dataset.variant || '46243130867864';
    _selectedFabric = el.dataset.fabric || el.dataset.color || null;
    _selectedColorName = el.dataset.color || el.dataset.fabric || null;
    setText('scs-color-summary', _selectedColorName || 'Select color');
    updateDeliveryCopy();
    // Swap gallery hero image by clicking the matching thumbnail via data-media-id
    var mediaId = el.dataset.mediaId;
    if (mediaId) {
      var thumb = document.querySelector('a.product-gallery__thumbnail[data-media-id="' + mediaId + '"]');
      if (thumb) {
        thumb.click();
      }
    }
  };

  // ── Day fabric selection (Day & Night only) ──
  window.scsSelectDayFabric = function (el) {
    document.querySelectorAll('.scs-day-color-card').forEach(function (c) {
      c.classList.remove('active');
    });
    el.classList.add('active');
    _selectedDayFabric = el.dataset.fabric || null;
    _selectedDayFabricName = el.dataset.color || null;
    setText('scs-day-color-summary', _selectedDayFabricName || 'Select sheer');
  };

  // ── Rail selection ──
  window.scsSelectRail = function (el) {
    document.querySelectorAll('.scs-rail-card').forEach(function (c) {
      c.classList.remove('active');
    });
    el.classList.add('active');
    _selectedRail = el.dataset.rail || null;
    _selectedRailName = el.dataset.railName || null;
    setText('scs-rail-summary', _selectedRailName || 'Select rail');
  };

  // ── Mount selection ──
  window.scsSelectMount = function (mount, el) {
    _mount = mount;
    document.querySelectorAll('.scs-mount-btn').forEach(function (b) {
      b.classList.remove('active');
    });
    el.classList.add('active');
    setText('scs-mount-summary', mount + ' Mount');
  };

  // ── Lift selection ──
  window.scsSelectLift = function (lift, el) {
    _lift = lift;
    document.querySelectorAll('.scs-lift-card:not(.disabled)').forEach(function (card) {
      card.classList.remove('active');
    });
    if (el) el.classList.add('active');
    setText('scs-lift-summary', lift);
  };

  window.scsSelectPleatSize = function (val, el) {
    _pleatSize = val;
    document.querySelectorAll('[data-option-group="pleat-size"] .scs-mount-btn').forEach(function (b) {
      b.classList.remove('active');
    });
    if (el) el.classList.add('active');
    setText('scs-pleat-summary', val);
  };

  window.scsSelectLiftStyle = function (val, el) {
    if (el && el.classList.contains('disabled')) return;
    _liftStyle = val;
    document.querySelectorAll('[data-option-group="lift-style"] .scs-lift-card:not(.disabled)').forEach(function (card) {
      card.classList.remove('active');
      var badge = card.querySelector('.scs-lift-badge');
      if (badge) badge.textContent = 'Available';
    });
    if (el) {
      el.classList.add('active');
      var badge2 = el.querySelector('.scs-lift-badge');
      if (badge2) badge2.textContent = 'Selected';
    }
    setText('scs-lift-style-summary', val);
  };

  window.scsSelectBottomRail = function (val, el) {
    _bottomRail = val;
    document.querySelectorAll('[data-option-group="bottom-rail"] .scs-mount-btn').forEach(function (b) {
      b.classList.remove('active');
    });
    if (el) el.classList.add('active');
    setText('scs-bottom-rail-summary', val);
  };

  window.scsSelectBlackout = function (val, el) {
    if (val === 'Add Blackout Liner' && el && el.classList.contains('disabled')) return;
    _blackout = val;
    window._scsBlackout = val;
    document.querySelectorAll('[data-option-group="blackout"] .scs-lift-card:not(.disabled)').forEach(function (card) {
      card.classList.remove('active');
      var badge = card.querySelector('.scs-lift-badge');
      if (badge && badge.dataset.defaultLabel) badge.textContent = badge.dataset.defaultLabel;
    });
    if (el) {
      el.classList.add('active');
      var badge2 = el.querySelector('.scs-lift-badge');
      if (badge2) {
        if (!badge2.dataset.defaultLabel) badge2.dataset.defaultLabel = badge2.textContent;
        badge2.textContent = 'Selected';
      }
    }
    var colors = document.getElementById('scs-colors');
    var note = document.getElementById('scs-laminated-note');
    if (val === 'Laminated Stone') {
      if (colors) colors.classList.add('scs-colors-disabled');
      if (note) note.classList.add('visible');
    } else {
      if (colors) colors.classList.remove('scs-colors-disabled');
      if (note) note.classList.remove('visible');
    }
    setText('scs-blackout-summary', val === 'None' ? 'No Blackout' : val);
    updatePriceBar();
  };

  // ── Quantity ──
  window.scsAdjQty = function (delta) {
    var inp = document.getElementById('scs-qty');
    var v = parseInt(inp.value) + delta;
    inp.value = Math.max(1, Math.min(20, v));
    updatePriceBar();
  };

  // ── Bracket selection ──
  var _selectedBracketVariant = '48859050180760';
  var _selectedBracketName = 'United Pleated Bracket';
  var _selectedBracketPrice = 9.97;

  window.scsSelectBracket = function(el) {
    document.querySelectorAll('#scs-brackets .scs-color-card').forEach(function(c) { c.classList.remove('active'); });
    el.classList.add('active');
    _selectedBracketVariant = el.dataset.bracketVariant;
    _selectedBracketName = el.dataset.bracketName;
    _selectedBracketPrice = parseFloat(el.dataset.bracketPrice) || 0;
  };

  window.scsAdjBrackets = function(delta) {
    var inp = document.getElementById('scs-brackets-extra');
    if (!inp) return;
    var v = Math.max(0, Math.min(10, parseInt(inp.value) + delta));
    inp.value = v;
    var costEl = document.getElementById('scs-bracket-extra-cost');
    if (costEl) costEl.textContent = v > 0 ? ('+ $' + (v * _selectedBracketPrice).toFixed(2) + ' for extra brackets') : '';
  };

  // ── Build payload (shared between Save and ATC) ──
  window.buildProjectPayload = function () {
    var wWhole = document.getElementById('scs-width-whole').value;
    var wFrac  = document.getElementById('scs-width-frac').value;
    var hWhole = document.getElementById('scs-height-whole').value;
    var hFrac  = document.getElementById('scs-height-frac').value;
    var qty    = parseInt(document.getElementById('scs-qty').value) || 1;

    if (!wWhole || parseFloat(wWhole) < 1) return { error: 'Please select a width.' };
    if (!hWhole || parseFloat(hWhole) < 1) return { error: 'Please select a height.' };
    if (!_selectedVariant)                 return { error: 'Please select a color.' };

    var w = parseFloat(wWhole) + (parseFloat(wFrac) || 0);
    var h = parseFloat(hWhole) + (parseFloat(hFrac) || 0);
    var widthStr  = fmtDim(wWhole, wFrac);
    var heightStr = fmtDim(hWhole, hFrac);

    if (SCS.variantMode === 'by_size_tier') {
      if (SCS.sizeTierVariants) {
        var wt = getBucketIndex(w, ACTIVE_PRICE_BUCKETS.width);
        var ht = getBucketIndex(h, ACTIVE_PRICE_BUCKETS.height);
        var tierKey = wt + '/' + ht;
        var tierVariant = SCS.sizeTierVariants[tierKey] || SCS.sizeTierVariants[String(tierKey)] || null;
        if (tierVariant) _selectedVariant = tierVariant;
      }
      if (!_selectedVariant) {
        var firstColorCard = document.querySelector('#scs-colors .scs-color-card');
        if (firstColorCard && firstColorCard.dataset.variant) _selectedVariant = firstColorCard.dataset.variant;
      }
    }

    var props = {
      'Width':           widthStr,
      'Height':          heightStr,
      'Fabric Color':    (_blackout === 'Laminated Stone') ? 'Laminated Stone' : (_selectedFabric || _selectedColorName),
      'Mount':           _mount,
      '_builder_source': SCS.builderSource || (_isDayNight ? 'shade-pleated-dn-v2' : 'shade-pleated-v2')
    };
    if (SCS.variantMode !== 'by_size_tier') props['Lift'] = _lift;
    if (_isDayNight && _selectedDayFabric) props['Day Fabric Color'] = _selectedDayFabricName || _selectedDayFabric;
    if (SCS.showRailColor !== false && _selectedRail) props['Rail Color'] = _selectedRailName || _selectedRail;
    if (_pleatSize) props['Pleat Size'] = _pleatSize;
    if (_liftStyle) props['Lift Style'] = _liftStyle;
    if (_bottomRail) props['Bottom Rail'] = _bottomRail;
    if (_blackout) props['Blackout Add-on'] = _blackout;
    if (_blackout === 'Add Blackout Liner') props['_blackout_upcharge'] = '$' + getBlackoutUpcharge(w, h);

    var wnEl = document.getElementById('scs-window-name');
    if (wnEl && wnEl.value.trim()) props['Window Name'] = wnEl.value.trim();

    var shadeLabel = ['Pleated', _selectedColorName || 'Custom', 'Shade'].filter(Boolean).join(' ');

    // For legacy Day & Night mappings: look up correct variant from sizeTierVariants
    if (_isDayNight && SCS.sizeTierVariants && SCS.variantMode !== 'by_size_tier') {
      var wf = parseFloat(w), hf = parseFloat(h);
      var wBucket = wf <= 30 ? '0-30' : (wf <= 48 ? '31-48' : '49-76');
      var hBucket = hf <= 24 ? '0-24' : (hf <= 40 ? '25-40' : '41-65');
      var tierKey = wBucket + '/' + hBucket;
      var tierVariant = SCS.sizeTierVariants[tierKey];
      if (tierVariant) _selectedVariant = tierVariant;
    }

    return {
      variantId:   _selectedVariant,
      quantity:    qty,
      widthStr:    widthStr,
      heightStr:   heightStr,
      summaryText: widthStr + ' × ' + heightStr + ' — ' + _mount + ' Mount' + (_liftStyle ? (' — ' + _liftStyle) : (' — ' + _lift)),
      properties:  props,
      projectShade: {
        id:                  'shade-' + Date.now(),
        brand:               SCS.brand,
        shadeType:           SCS.shadeType,
        config:              SCS.shadeConfig,
        width:               String(w),
        height:              String(h),
        mountType:           _mount,
        liftType:            _liftStyle || _lift,
        nightFabric:         _selectedFabric || null,
        dayFabric:           _selectedDayFabric || null,
        fabric:              _selectedFabric || null,
        railColor:           SCS.showRailColor === false ? null : (_selectedRail || null),
        label:               shadeLabel,
        quantity:            qty,
        sourceVariantId:     String(_selectedVariant),
        color:               _selectedColorName || null,
        properties:          props,
        sourceProductHandle: SCS.sourceProductHandle || null,
        sourceProductTitle:  SCS.sourceProductTitle || null
      }
    };
  };

  // ── Save to Project ──
  window.scsSaveProject = function () {
    clearMsg();
    var payload = window.buildProjectPayload();
    if (payload.error) { showMsg('error', payload.error); return; }
    var btn = document.getElementById('scs-save-btn');
    var msg = document.getElementById('scs-msg');
    if (typeof window.ervpSaveShadePdpProject === 'function') {
      return window.ervpSaveShadePdpProject(btn, msg);
    } else {
      showMsg('error', 'Project save unavailable. Please use Add to Cart.');
    }
  };

  // ── Add to Cart ──
  window.scsAddToCart = function () {
    clearMsg();
    var payload = window.buildProjectPayload();
    if (payload.error) { showMsg('error', payload.error); return; }

    var btn = document.getElementById('scs-atc-btn');
    btn.disabled = true;
    btn.textContent = 'Adding…';

    // Build items array: shade + brackets
    var items = [{
      id:         payload.variantId,
      quantity:   payload.quantity,
      properties: payload.properties
    }];
    if (_selectedBracketVariant && document.getElementById('scs-brackets')) {
      var extraBrackets = parseInt((document.getElementById('scs-brackets-extra') || {}).value) || 0;
      var freeBracketQty = payload.quantity * 2;
      // Free brackets use the $0 "Included Free" variant
      items.push({
        id:       '48859050213528',
        quantity: freeBracketQty,
        properties: { '_included_with_shade': '2 per shade' }
      });
      // Extra brackets at full price use the standard variant
      if (extraBrackets > 0) {
        items.push({
          id:       _selectedBracketVariant,
          quantity: extraBrackets,
          properties: { '_extra_brackets': 'Yes' }
        });
      }
    }
    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ items: items })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      btn.disabled = false;
      btn.textContent = 'Add to Cart';
      if (data.id || data.items) {
        showMsg('success', '✓ Added to cart! ' + payload.summaryText);
        setTimeout(function () { window.location.href = '/cart'; }, 1400);
      } else {
        showMsg('error', data.description || data.message || 'Could not add to cart. Please try again.');
      }
    })
    .catch(function () {
      btn.disabled = false;
      btn.textContent = 'Add to Cart';
      showMsg('error', 'Something went wrong. Please try again.');
    });
  };

  // ── Global shade list / multi-shade functions ──
  window.scsRemoveShade = function(idx) {
    _savedShades.splice(idx, 1);
    renderShadeList();
    updatePriceBar();
  };

  window.scsAddAnotherShade = function() {
    var payload = window.buildProjectPayload();
    if (payload.error) { showMsg('error', payload.error); return; }

    // Calculate price for this shade
    var wMatch = payload.widthStr && payload.widthStr.match(/([\d.]+)/);
    var hMatch = payload.heightStr && payload.heightStr.match(/([\d.]+)/);
    var price = null;
    if (wMatch && hMatch) {
      price = getBasePrice(parseFloat(wMatch[1]), parseFloat(hMatch[1]));
    }

    var shadeEntry = Object.assign({}, payload, {
      price: price,
      label: [
        payload.projectShade && payload.projectShade.shadeType || 'Pleated',
        payload.projectShade && payload.projectShade.nightFabric || _selectedColorName || '',
        'Shade'
      ].filter(Boolean).join(' ')
    });

    _savedShades.push(shadeEntry);
    renderShadeList();

    var btn = document.getElementById('scs-save-btn');
    var origText = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Saved ✓'; }
    setTimeout(function() {
      if (btn) { btn.disabled = false; btn.textContent = origText; }
    }, 1200);

    scsResetForm();
  };

  window.scsAddAllToCart = function() {
    if (_savedShades.length === 0) return;
    var btn = document.getElementById('scs-add-all-btn');
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    // Include free brackets for each shade (2 per shade)
    var items = [];
    _savedShades.forEach(function(shade) {
      items.push({
        id: shade.variantId,
        quantity: shade.quantity || 1,
        properties: shade.properties || {}
      });
      // Free brackets
      if (document.getElementById('scs-brackets')) {
        items.push({
          id: '48859050213528',
          quantity: (shade.quantity || 1) * 2,
          properties: { '_included_with_shade': '2 per shade' }
        });
      }
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.items || data.id) {
        window.location.href = '/cart';
      } else {
        if (btn) { btn.disabled = false; btn.textContent = 'Add All to Cart'; }
        showMsg('error', data.description || 'Could not add to cart. Please try again.');
      }
    })
    .catch(function() {
      if (btn) { btn.disabled = false; btn.textContent = 'Add All to Cart'; }
      showMsg('error', 'Something went wrong. Please try again.');
    });
  };

  // ── Init ── (runs whether DOM is ready or not)
  function scsInit() {
    // Stop ALL change/input events from bubbling out of the shade config
    // to prevent product-rerender from triggering a full section reload
    var wrap = document.getElementById('scs-root');
    if (wrap && !wrap.dataset.scsReady) {
      wrap.dataset.scsReady = '1';
      ['change','input'].forEach(function(evt) {
        wrap.addEventListener(evt, function(e) { e.stopPropagation(); }, true);
      });
    }

    var colorContainer = document.getElementById('scs-colors');
    if (colorContainer && !colorContainer.dataset.scsReady) {
      colorContainer.dataset.scsReady = '1';
      colorContainer.addEventListener('mousedown', function(e) {
        if (e.target.closest('.scs-color-card')) { e.stopPropagation(); }
      }, true);
      colorContainer.addEventListener('click', function(e) {
        var card = e.target.closest('.scs-color-card');
        if (card) { e.preventDefault(); e.stopPropagation(); window.scsSelectColor(card); }
      }, true);
    }
    var bracketContainer = document.getElementById('scs-brackets');
    if (bracketContainer && !bracketContainer.dataset.scsReady) {
      bracketContainer.dataset.scsReady = '1';
      bracketContainer.addEventListener('click', function(e) {
        var card = e.target.closest('.scs-color-card');
        if (card) { e.preventDefault(); e.stopPropagation(); window.scsSelectBracket(card); }
      }, true);
    }
    ['scs-width-whole','scs-width-frac','scs-height-whole','scs-height-frac'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) {
        el.addEventListener('change', function (e) {
          e.stopPropagation(); // prevent product-rerender from triggering a full section reload
          updateSizeSummary();
          updateDeliveryCopy();
          updateUnitedConstraints();
          updatePriceBar();
        });
        el.addEventListener('input', function(e) {
          e.stopPropagation();
          updateSizeSummary();
          updateUnitedConstraints();
          updatePriceBar();
        });
      }
    });
    var firstActiveColor = document.querySelector('#scs-colors .scs-color-card.active') || document.querySelector('#scs-colors .scs-color-card');
    if (firstActiveColor) {
      _selectedVariant = firstActiveColor.dataset.variant || _selectedVariant;
      _selectedFabric = firstActiveColor.dataset.fabric || firstActiveColor.dataset.color || _selectedFabric;
      _selectedColorName = firstActiveColor.dataset.color || firstActiveColor.dataset.fabric || _selectedColorName;
    }
    var activeDay = document.querySelector('#scs-day-colors .scs-day-color-card.active');
    if (activeDay) {
      _selectedDayFabric = activeDay.dataset.fabric || null;
      _selectedDayFabricName = activeDay.dataset.color || null;
    }
    var activePleat = document.querySelector('[data-option-group="pleat-size"] .scs-mount-btn.active');
    if (activePleat) _pleatSize = activePleat.dataset.pleat || activePleat.dataset.value || activePleat.textContent.trim();
    var activeLiftStyle = document.querySelector('[data-option-group="lift-style"] .scs-lift-card.active');
    if (activeLiftStyle) _liftStyle = activeLiftStyle.dataset.liftStyle || activeLiftStyle.dataset.value || activeLiftStyle.dataset.lift || activeLiftStyle.textContent.trim();
    var activeBottomRail = document.querySelector('[data-option-group="bottom-rail"] .scs-mount-btn.active');
    if (activeBottomRail) _bottomRail = activeBottomRail.dataset.bottomRail || activeBottomRail.dataset.rail || activeBottomRail.dataset.value || activeBottomRail.textContent.trim();
    var activeBlackout = document.querySelector('[data-option-group="blackout"] .scs-lift-card.active');
    if (activeBlackout) {
      _blackout = activeBlackout.dataset.blackout || activeBlackout.dataset.value || activeBlackout.textContent.trim();
      window._scsBlackout = _blackout;
    }

    setText('scs-color-summary', _selectedColorName);
    setText('scs-mount-summary', _mount + ' Mount');
    if (_isDayNight) setText('scs-day-color-summary', _selectedDayFabricName || 'Select sheer');
    setText('scs-lift-summary', _lift);
    if (SCS.showRailColor !== false) setText('scs-rail-summary', 'Select rail');
    updateSizeSummary();
    updateDeliveryCopy();
    updateUnitedConstraints();
    updatePriceBar();
    renderShadeList();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      scsInit();
      watchForRerender();
    });
  } else {
    scsInit();
    watchForRerender();
  }

  // Re-init when product-rerender replaces the buy_buttons DOM
  function watchForRerender() {
    var rerender = document.querySelector('product-rerender');
    if (!rerender) return;
    new MutationObserver(function() {
      // Small delay to let the new HTML settle
      setTimeout(scsInit, 50);
    }).observe(rerender, { childList: true, subtree: true });
  }
})();
